import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>Vlees: gezond of gif?</title>
                <link rel="canonical" href={route("blogs.twenty-five")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="WE ARE – Personal Training Uden en Schijndel komt met een nieuwe blog. In deze blog openen we de discussie over het consumeren van vlees. Zijn we hier als mensen wel voor gemaakt en wat doet het met ons lichaam als we minder vlees zouden eten? Documentaires als THE GAME CHANGEGAMERS en WHAT THE HEALTH geven hier een beeld over vanuit één optiek. In deze blog bekijken we het van beide kanten."
                />
                <meta
                    property="og:description"
                    content="WE ARE – Personal Training Uden en Schijndel komt met een nieuwe blog. In deze blog openen we de discussie over het consumeren van vlees. Zijn we hier als mensen wel voor gemaakt en wat doet het met ons lichaam als we minder vlees zouden eten? Documentaires als THE GAME CHANGEGAMERS en WHAT THE HEALTH geven hier een beeld over vanuit één optiek. In deze blog bekijken we het van beide kanten."
                />
                <meta property="og:url" content={route("blogs.twenty-five")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Vlees: gezond of gif? - WE ARE Personal Training Uden en Schijndel"
                />
                <meta property="og:image" content="/assets/blog/vlees.jpg" />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh] pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/vlees.webp"
                                    type="image/webp"
                                    alt="Vlees"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/vlees.jpg"
                                    type="image/jpeg"
                                    alt="Vlees"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/vlees.jpg"
                                    alt="Vlees"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Vlees: gezond of gif?
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        WE ARE – Personal Training Uden en Schijndel komt met
                        een nieuwe blog. In deze blog openen we de discussie
                        over het consumeren van vlees. Zijn we hier als mensen
                        wel voor gemaakt en wat doet het met ons lichaam als we
                        minder vlees zouden eten? Documentaires als THE GAME
                        CHANGEGAMERS en WHAT THE HEALTH geven hier een beeld
                        over vanuit één optiek. In deze blog bekijken we het van
                        beide kanten.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Zijn we als mensen geschikt voor vlees?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Wanneer we kijken naar ons gebit zijn we als mensen
                        ontworpen als omnivoren. Dit betekent dat we zowel vlees
                        als planten eten. We hebben namelijk vier snijtanden
                        voor het scheuren van vlees en een flinke partij kiezen
                        voor op planten te kauwen. Daarnaast produceert ons
                        lichaam enzymen die bestemd zijn voor het verteren en
                        opnemen van vlees. Dit wijst erop dat de natuur ons in
                        elkaar heeft gezet om zowel planten als vlees te eten.
                        Ook is het belangrijk dat we als mensen ooit vlees eten.
                        Bepaalde voedingstoffen die we uit vlees halen kunnen we
                        niet uit planten halen zoals vitamine B12. Wanneer je
                        vlees dus helemaal uit je voeding zou schrappen is de
                        kans groot dat je tekorten krijgt in bepaalde
                        voedingsstoffen. Daarnaast is vlees belangrijke bron van
                        <a
                            href={route("blogs.third")}
                            className="text-we-are-yellow"
                        >
                            eiwitten
                        </a>{" "}
                        die belangrijk zijn voor het lichaam om bijvoorbeeld{" "}
                        <a
                            href={route("blogs.ninth")}
                            className="text-we-are-yellow"
                        >
                            spiermassa
                        </a>{" "}
                        te kunnen behouden.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Vlees schrappen dus niet, wel minderen?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Het minderen van vlees is echter wel aan te raden om
                        gezonder en vitaler door het leven te gaan. Hierdoor
                        hoef je niet direct vlees te schrappen uit je
                        voedingspatroon maar het starten met een of twee dagen
                        zonder vlees is al een begin. Gezondheidsvoordelen die
                        het gevolg zijn van minder vlees zijn o.a.:
                    </p>
                    {/*  */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-xl sm:text-xl">
                        1. Het makkelijker verliezen van lichaamsgewicht
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        Studies tonen aan dat mensen die minder vlees eten
                        aanzienlijk meer en sneller gewicht verliezen dan mensen
                        die dagelijks vlees eten. Deze onderzoeken lieten zien
                        dat de controle groep aanzienlijk meer gewicht verloor
                        na 18 weken een vegetarisch dieet te hebben gevolgd.
                        (Huang, 2016).
                    </p>
                    {/* -- */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-xl sm:text-xl">
                        2. Kan de darmgezondheid verbeteren
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        Vlees wordt vervangen door meer fruit, groente, noten en
                        zaden. Deze producten bevatten vezels die weer goed zijn
                        voor je darmen. Deze vezels activeren de goede bacteriën
                        die waren als ontstekingsremmers voor het lichaam. Vlees
                        consumeren in grote hoeveelheden veroorzaken het
                        tegenovergestelde en dus wil je dit graag voorkomen om
                        de gezondheid van je darmen te verbeteren.
                    </p>
                    {/* -- */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-xl sm:text-xl">
                        3. Verkleinen van de kans op kanker
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        Onderzoeken tonen aan dat het eten van rood en bewerkt
                        vlees de kans op kanker vergroot (Zhao, 2017).
                        Vleessoorten als gevogelte en kip laten dit verband niet
                        zien waardoor het wordt aangeraden om deze vormen van
                        vlees te eten wanneer je vlees eet.
                    </p>
                    {/*  */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl">
                        Bibliografie
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        Huang, R.-Y. (2016, janauri 31). Opgehaald van{" "}
                        <a
                            href="https://pubmed.ncbi.nlm.nih.gov/26138004/"
                            rel="noopener"
                            className="text-we-are-yellow"
                        >
                            https://pubmed.ncbi.nlm.nih.gov/26138004/{" "}
                        </a>
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Zhao, Z. (2017, oktober 10). Opgehaald van{" "}
                        <a
                            href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC5669970/"
                            rel="noopener"
                            className="text-we-are-yellow"
                        >
                            https://www.ncbi.nlm.nih.gov/pmc/articles/PMC5669970/{" "}
                        </a>
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
